import type { Campaign } from '../campaigns/model';
import { readCampaignClaimPolicy } from '../taskPolicy/claims';

type CampaignLimits = Pick<
  Campaign,
  'maxClaimedTasksPerUser' | 'maxTasksPerUser' | 'maxTasksPerTrustedUser' | 'requireFirstApprovalBeforeMoreClaims'
>;

/** Describe the same normalized limits enforced by the claim command. */
export function campaignLimitsMessage(
  campaign: CampaignLimits | null,
  isTrusted = false,
): string | null {
  if (!campaign) return null;
  const policy = readCampaignClaimPolicy({ ...campaign }, '', null, isTrusted);
  const taskLabel = (count: number) => (count === 1 ? 'task' : 'tasks');
  const active =
    policy.maxClaimedTasks === null
      ? null
      : `${policy.maxClaimedTasks} claimed or in-progress ${taskLabel(policy.maxClaimedTasks)} at any one time`;
  const total =
    policy.maxTasks === null
      ? null
      : `${policy.maxTasks} ${taskLabel(policy.maxTasks)} in total across all states`;
  let message: string;
  if (active && total) {
    message = `This campaign allows you to hold up to ${active} and a maximum of ${total}.`;
  } else if (active) {
    message = `This campaign allows you to hold up to ${active}. There is no total task limit.`;
  } else if (total) {
    message = `This campaign allows you to have a maximum of ${total}. There is no separate limit on claimed or in-progress tasks.`;
  } else {
    message = '';
  }
  if (policy.firstApproval)
    message += ' Your first task in this campaign must be approved before you can claim another.';
  return message.trim() || null;
}
